module.exports = __webpack_public_path__ + "img/nasolabial_female_average.cf00af40.png";